import React from 'react';
import TermsAndCondition from './TermsAndCondition';
import Contact from './Contact';
import ReturnPolicy from './ReturnPolicy';
import Prybacy from './Prybacy';
import Delivery from './Delivery';
//import './About.css'; // If you want to add custom CSS

const About = () => {

  const sectionStyle = {
    padding: '50px',
    backgroundColor: '#f4f4f4',
    textAlign: 'justify',
  };

  const containerStyle = {
    maxWidth: '800px',
    margin: '0 auto',
  };

  const headingStyle = {
    fontSize: '2.5rem',
    marginBottom: '20px',
    textAlign: 'center',
  };

  const paragraphStyle = {
    fontSize: '1.2rem',
    lineHeight: '1.6',
    marginBottom: '20px',
  };

  return (
    <section style={sectionStyle}>
      <div style={containerStyle}>
        <h1 style={headingStyle}>About Us</h1>
        <p style={paragraphStyle}>
          Welcome to nooor.xyz, your one-stop destination for all your shopping needs. We are committed to offering a wide range of high-quality products at affordable prices, ensuring a seamless shopping experience from start to finish. Whether you're looking for the latest fashion trends, must-have electronics, or unique home goods, we've got you covered. Our goal is to provide exceptional customer service, fast shipping, and a user-friendly platform that makes online shopping both fun and easy. Thank you for choosing us – we’re here to make your shopping experience as convenient and enjoyable as possible. Name: Imran Traders Trade license Number: 6399 "আপনার সমস্ত কেনাকাটার প্রয়োজনের জন্য আপনার ওয়ান-স্টপ গন্তব্য nooor.xyz এ স্বাগতম। আমরা সাশ্রয়ী মূল্যে বিস্তৃত উচ্চ-মানের পণ্য অফার করতে প্রতিশ্রুতিবদ্ধ, শুরু থেকে শেষ পর্যন্ত বিরামহীন কেনাকাটার অভিজ্ঞতা নিশ্চিত করে। আপনি সাম্প্রতিক ফ্যাশন প্রবণতা খুঁজছেন, ইলেকট্রনিক্স থাকা আবশ্যক, বা অনন্য গৃহসামগ্রী, আমরা আপনাকে কভার করেছি। আমাদের লক্ষ্য হল ব্যতিক্রমী গ্রাহক পরিষেবা, দ্রুত শিপিং এবং একটি ব্যবহারকারী-বান্ধব প্ল্যাটফর্ম প্রদান করা যা অনলাইন শপিংকে মজাদার এবং সহজ করে তোলে। আমাদের বেছে নেওয়ার জন্য আপনাকে ধন্যবাদ – আমরা আপনার কেনাকাটার অভিজ্ঞতাকে যতটা সম্ভব সুবিধাজনক এবং আনন্দদায়ক করতে এখানে আছি।"
        </p>
        <Contact/>
        <TermsAndCondition/>
        <ReturnPolicy/>
        <Prybacy/>
        <Delivery/>
      </div>
    </section>
  );
};

export default About;
